export const activitiesHomeRootRoute = 'activities';
